module.exports = __webpack_public_path__ + "img/03.b88a7a87.svg";